import { resolveImagePath } from '@/utils/imageMap';

export function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full md:h-[500px] h-auto bg-beige overflow-hidden"
    >
      <div className="max-w-7xl mx-auto h-full flex items-center md:px-8 px-0">
        {/* Desktop Layout: Logo on left, Image on right */}
        <div className="hidden md:flex items-center w-full h-full gap-12">
          {/* Logo */}
          <div className="flex-shrink-0 w-1/3">
            <img
              src={resolveImagePath('/images/logo.png')}
              alt="The Conservatory of Musical Arts"
              className="w-full max-w-[400px] h-auto"
            />
          </div>

          {/* Hero Image - Natural full height (500px) */}
          <div className="flex-1 h-full flex items-center justify-end">
            <img
              src={resolveImagePath('/images/CMABanner.jpg')}
              alt="Young student at The Conservatory of Musical Arts"
              className="h-full w-auto object-cover"
            />
          </div>
        </div>

        {/* Mobile Layout: Full-width image, logo is in header */}
        <div className="md:hidden w-full min-h-[200px] flex items-center bg-beige">
          <img
            src={resolveImagePath('/images/CMABanner-mobile.jpg')}
            alt="Young student at The Conservatory of Musical Arts"
            className="w-full h-auto min-h-[200px] object-cover"
          />
        </div>
      </div>
    </section>
  );
}